import { useEffect, useState } from 'react';
import Comments from './comments';
import {
  Button,
  CircularProgress,
  FormControl,
  TextField,
  Typography
} from '@mui/material';
import { colorLinkGrey, colorTextBlack } from '../../config/theme';
import { useDispatch, useSelector } from 'react-redux';
import { addComments, gamification } from '../../redux/reducers/resourcesSlice';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const CommentSection = ({
  comments,
  handleCommentList,
  commentsCount,
  contentId,
  handleUpdateComment,
  commentPoints,
  allowPoints
}) => {
  const [comment, setComment] = useState('');
  const [isShowAllComments, setIsShowAllComments] = useState(false);
  const { authData } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const userId = authData?.userId;
  const userName = authData?.userName;

  const { isAddCommentsLoading, isAddCommentsSuccess, addCommentsResponse } =
    useSelector(state => state.resource);

  const handleChange = e => {
    const { value } = e.target;
    if (value?.length < 201) {
      setComment(value);
    }
  };

  const handleShowText = id => {
    handleCommentList(id);
  };

  const handleAddComment = () => {
    let payload = {
      message: comment || '',
      contentId: contentId || 0,
      userId: userId || 0,
      loggedInUserName: userName || ''
    };

    dispatch(addComments({ payload }));
    if (authData?.role === 'I am a student') {
      if (allowPoints) {
        let gamificationPayload = {
          userId: userId || 0,
          contentId: contentId || 0,
          point: commentPoints || 0,
          type: 'comment',
          loggedInUserName: userName || ''
        };
        dispatch(gamification({ gamificationPayload }));
      }
    }
  };

  useEffect(() => {
    if (!isAddCommentsLoading && isAddCommentsSuccess && addCommentsResponse) {
      setComment('');
      handleUpdateComment();
    }
  }, [isAddCommentsLoading, isAddCommentsSuccess]);

  const handleShowComments = () => {
    setIsShowAllComments(!isShowAllComments);
  };

  const mappingContent =
    comments.length > 0
      ? isShowAllComments
        ? comments
        : comments?.slice(0, 2)
      : [];

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <Typography
          style={{
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '20px',
            color: colorTextBlack
          }}
        >
          {commentsCount} Comments
        </Typography>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '10px'
          }}
        >
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
          >
            <FormControl variant="outlined" fullWidth size="small">
              <TextField
                name="comment"
                placeholder="Write comment here..."
                variant="outlined"
                size="small"
                maxRows={2}
                sx={{
                  '& textarea': {
                    '&::-webkit-scrollbar-track': {
                      background: '#f5f5f5',
                      borderRadius: '10px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#4E565F',
                      borderRadius: '10px',
                      border: '2px solid #4E565F'
                    }
                  }
                }}
                inputProps={{
                  maxLength: 200
                }}
                value={comment}
                onChange={e => handleChange(e)}
                onKeyDown={e => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    if (comments?.length) {
                      handleAddComment();
                    }
                  }
                }}
              />
            </FormControl>
            <Typography
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                fontFamily: 'Lato',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '18px',
                color: colorLinkGrey
              }}
            >
              {comment?.length || 0}/200
            </Typography>
          </div>

          <Button
            variant="contained"
            disabled={!comment?.length}
            sx={{
              px: 4,
              borderWidth: 2,
              width: '90px',
              borderRadius: '8px',
              marginLeft: '10px'
            }}
            onClick={handleAddComment}
          >
            {isAddCommentsLoading ? <CircularProgress size={20} /> : 'Add'}
          </Button>
        </div>
      </div>
      {mappingContent?.map(comment => (
        <Comments
          key={comment.id}
          comment={comment}
          index={comment.id}
          handleShow={handleShowText}
          contentId={contentId}
          isShowAllComments={isShowAllComments}
          parentId={comment.id}
          commentPoints={commentPoints}
          allowPoints={allowPoints}
        />
      ))}

      {comments.length > 2 && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            marginTop: '10px'
          }}
          onClick={handleShowComments}
        >
          <Typography
            style={{
              fontSize: '14px',
              lineHeight: '18px',
              fontWeight: 700,
              fontFamily: 'Lato',
              color: colorTextBlack
            }}
          >
            {!isShowAllComments ? 'View All Comments' : 'View Less Comments'}
          </Typography>
          {!isShowAllComments ? (
            <KeyboardArrowDownIcon />
          ) : (
            <KeyboardArrowUpIcon />
          )}
        </div>
      )}
    </div>
  );
};

export default CommentSection;
